export default {
  SET_CURRENT_OPERATOR(state, operator) {
    state.operator = operator;
  },
  SET_OPERATORS_LIST(state, operators) {
    state.operatorsList = operators;
  },
};
